/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import i18n from 'i18next';

import { getLearnerPermissionsGroups, ExceedGroupsCustomListItem, ExceedGroupsCustomMenu } from '@/exceed';

export default () => {
  const type = window.location.pathname.includes('topic-permissions') ? 'topic' : 'video';

  const CustomComponent = (props) => (
    <ExceedGroupsCustomListItem
      {...props}
      buttonAriaLabel={i18n.t('remove-learner-permissions')}
    />
  );

  return {
    title: i18n.t('learner-permissions-label'),
    body: i18n.t('learner-permissions-body'),
    schema: {
      access_type: {
        type: 'Radio',
        label: i18n.t('catalog-access-label'),
        help: type === 'topic' ? i18n.t('catalog-access-topic-body') : i18n.t('catalog-access-video-body'),
        options: [
          {
            id: 1,
            label: i18n.t('none'),
            value: 'none',
          },
          {
            id: 2,
            label: i18n.t('restricted'),
            value: 'restricted',
          },
          {
            id: 3,
            label: i18n.t('all-users'),
            value: 'all',
          },
        ],
      },
      accessible_by: {
        type: 'AutoCompleteSearch',
        label: i18n.t('permissions-label'),
        handleLoadOptions: getLearnerPermissionsGroups,
        CustomSelectedOptionItem: CustomComponent,
        emptyStateText: i18n.t('permissions-empty-state'),
        selectProps: {
          placeholder: i18n.t('add-groups'),
          components: { Option: ExceedGroupsCustomMenu },
        },
        conditions: [{ type: 'isAccessRestricted', shouldHideField: true }],
      },
    },
  };
};
